import { supabase } from "@/lib/supabase";

interface AuditParams {
  userId: string | null;
  userName: string;
  action: string;
  entity: string;
  entityId: string;
  branchId?: string | null;
  oldValue?: Record<string, unknown> | null;
  newValue?: Record<string, unknown> | null;
}

/** Registers an important action in the audit trail. Never blocks the main flow. */
export async function logAudit({
  userId,
  userName,
  action,
  entity,
  entityId,
  branchId = null,
  oldValue = null,
  newValue = null,
}: AuditParams): Promise<void> {
  try {
    await supabase.from("audit_logs").insert({
      user_id: userId,
      user_name: userName,
      action,
      entity,
      entity_id: entityId,
      branch_id: branchId,
      old_value: oldValue,
      new_value: newValue,
    });
  } catch {
    // Auditing must never break the operation.
  }
}